var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0998 13.4C2.5998 13.4 2.0998 13.2 1.7998 12.9C1.4998 12.6 1.2998 12.1 1.2998 11.6V4.49995C1.2998 3.49995 2.0998 2.69995 3.0998 2.69995H12.8998C13.8998 2.69995 14.6998 3.49995 14.6998 4.49995V11.6C14.6998 12.6 13.8998 13.4 12.8998 13.4H3.0998ZM3.0998 4.09995C2.8998 4.09995 2.7998 4.29995 2.7998 4.39995V11.5C2.7998 11.6 2.8998 11.7 2.8998 11.7C2.8998 11.7 2.9998 11.8 3.0998 11.8H12.8998C13.0998 11.8 13.1998 11.6 13.1998 11.5V4.49995C13.1998 4.29995 12.9998 4.19995 12.8998 4.19995H3.0998V4.09995Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 8.69993C7.59999 8.69993 7.19999 8.59993 6.79999 8.29993L1.59999 4.69993C1.29999 4.39993 1.19999 3.99993 1.49999 3.59993C1.69999 3.29993 2.19999 3.19993 2.49999 3.39993L7.59999 7.09993C7.79999 7.19993 8.09999 7.19993 8.29999 7.09993L13.5 3.39993C13.8 3.19993 14.3 3.19993 14.5 3.59993C14.7 3.89993 14.7 4.39993 14.3 4.59993L9.19999 8.29993C8.79999 8.59993 8.39999 8.69993 7.99999 8.69993Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelope);
export default __webpack_public_path__ + "static/media/icon-envelope.6cdc75fa3bc93932e898f27f8bef492f.svg";
export { ForwardRef as ReactComponent };